import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../auth/auth.guard';
import { SharedModule } from '../shared/shared.module';
import { ComplaintStatusService } from './complaint-status.service';
import { ComplaintStatusCreateComponent } from './create/create.component';
import { ComplaintStatusEditComponent } from './edit/edit.component';
import { ComplaintStatusFormComponent } from './form/form.component';
import { ComplaintStatusListComponent } from './list/list.component';

const routes: Routes = [
  {
    path: 'complaint-statuses',
    component: ComplaintStatusListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'complaint-statuses/create',
    component: ComplaintStatusCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'complaint-statuses/:id/edit',
    component: ComplaintStatusEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    ComplaintStatusListComponent,
    ComplaintStatusCreateComponent,
    ComplaintStatusFormComponent,
    ComplaintStatusEditComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, ComplaintStatusService],
})
export class ComplaintStatusRoutingModule {}
